<script>export let propertiesMap = void 0;
export let observationData = [];
const tableType = "report";
$:
  visibleProperties = propertiesMap ? Object.values(propertiesMap).filter((property) => property.column.visible).filter(
    (property) => property.column.position && property.column.position[tableType] !== void 0 && property.column.position[tableType] >= 0
  ).sort((p0, p1) => {
    const c0Index = p0.column.position ? p0.column.position[tableType] : void 0;
    const c1Index = p1.column.position ? p1.column.position[tableType] : void 0;
    if (c0Index !== void 0 && c0Index >= 0) {
      if (c1Index !== void 0 && c1Index >= 0) {
        if (c1Index != c0Index) {
          return c0Index - c1Index;
        } else {
          return p0.column.title.localeCompare(p1.column.title);
        }
      } else {
        return -1;
      }
    } else {
      if (c1Index !== void 0 && c1Index >= 0) {
        return 1;
      } else {
        return p0.column.title.localeCompare(p1.column.title);
      }
    }
  }) : void 0;
</script>

{#if visibleProperties && observationData}
	<table>
		<thead>
			<tr>
				{#each visibleProperties as property}
					<th>{property.column.title}</th>
				{/each}
			</tr>
		</thead>
		<tbody>
			{#each observationData as observationDatum (observationDatum.id)}
				<tr>
					{#each visibleProperties as property}
						<td>{@html property.display(observationDatum)}</td>
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
{/if}

<style>
	table {
		border: 0;
		border-collapse: collapse;
		width:100%;
	}
	thead {
		background-color: #404040;
		color: #ffffff;
	}
	thead th {
		border-left: 1px solid #ffffff;
	}
	thead th:nth-child(1) {
		border-left: 0;
	}
	tbody tr:nth-child(2n + 1) {
		background-color: hsla(0, 0%, 0%, 0.05);
	}
	tbody tr:nth-child(2n + 1) td:nth-child(2n) {
		background-color: hsla(0, 0%, 0%, 0.1);
	}
	tbody tr td:nth-child(2n) {
		background-color: hsla(0, 0%, 0%, 0.05);
	}

	@media print {
		/* All your print styles go here */

		tbody tr:nth-child(2n + 1),
		tbody tr:nth-child(2n + 1) td:nth-child(2n),
		tbody tr td:nth-child(2n) {
			background-color: transparent;
		}

		table tbody td {
			border: 1px solid #404040;
			padding: 0 2px;
		}
	}
</style>
